import WindTurbineService from "@/services/wind/WindTurbineService";
import TurbineActions from "./TurbineActions";
import TurbineMutations from "./TurbineMutations";

const state = WindTurbineService.EmptyWindTurbineStateFactory();

const { actions } = TurbineActions;

const { mutations } = TurbineMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	mutations,
};